import React from "react";
import { Dialog, Flex, Button } from "@fluentui/react-northstar";
import { FlexGap } from "shared/types/FlexGap";
import styles from "./responsiveDialog.module.scss";

interface ResponsiveDialogProps {
  header: string;
  content: string;
  confirmButton: string;
  cancelButton?: string;
  open?: boolean;
  trigger?: JSX.Element;
  gap?: FlexGap;
  isMobile?: boolean;

  onConfirm: () => void;
  onCancel?: () => void;
}

const ResponsiveDialog: React.FC<ResponsiveDialogProps> = (
  props: ResponsiveDialogProps
) => {
  return (
    <Dialog
      styles={{ padding: "16px" }}
      header={props.header}
      content={props.content}
      trigger={props.trigger}
      open={props.open}
      className={styles.wrapper}
      footer={{
        children: (_, footerProps) => {
          return (
            <Flex
              styles={footerProps.styles}
              hAlign={props.isMobile ? "center" : "end"}
            >
              <Flex
                gap={props.gap}
                column={props.isMobile}
                className={styles.buttonsWrapper}
              >
                {props.cancelButton && (
                  <Button
                    fluid={props.isMobile}
                    content={props.cancelButton}
                    secondary
                    onClick={props.onCancel}
                  />
                )}
                <Button
                  fluid={props.isMobile}
                  content={props.confirmButton}
                  primary
                  onClick={props.onConfirm}
                />
              </Flex>
            </Flex>
          );
        },
      }}
    />
  );
};

export default ResponsiveDialog;
